module.exports = __webpack_public_path__ + "static/media/ente-2-account-details.faa65fc1.png";